import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dateInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map